import React from "react";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  NewsTopSection,
  NewsListSection,
  NewsMiddleSection,
  NewsImageGallery,
  NewsVideoGallery,
} from "@modules/study/news/home";

const News = ({
  breakingNews,
  topStories,
  letestNews,
  popularStories,
  mustReadNews,
  imageGallery,
  videoGallery,
  tagsList,
  newsCountry,
}) => {
  return (
    <LayoutMain isHeaderSticky={true} title="News" footer_with_evaluation>
      {(breakingNews?.length > 0 || topStories?.length > 0) && (
        <NewsTopSection breakingNews={breakingNews} topStories={topStories} />
      )}
      <NewsListSection
        letestNews={letestNews}
        popularStories={popularStories}
        tagsList={tagsList}
        format="standard"
        newsCountry={newsCountry}
      />
      {mustReadNews && mustReadNews?.length > 0 && (
        <NewsMiddleSection mustReadNews={mustReadNews} />
      )}
      {imageGallery && imageGallery?.length > 0 && (
        <NewsImageGallery imageGallery={imageGallery} />
      )}
      {videoGallery && videoGallery?.length > 0 && (
        <NewsVideoGallery videoGallery={videoGallery} />
      )}
    </LayoutMain>
  );
};

export default News;

export async function getServerSideProps() {
  let props = {
    breakingNews: [],
    letestNews: [],
    topStories: [],
    popularStories: [],
    mustReadNews: [],
    imageGallery: [],
    videoGallery: [],
    tagsList: [],
    newsCountry: [],
  };

  try {
    await API.get(`/public/news/breaking-news/preview?limit=10`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.breakingNews = resp.data;
        }
      }
    );
    await API.get(`/public/news/top-stories/preview?limit=5`).then((resp) => {
      if (!resp.error && resp.data) {
        props.topStories = resp.data;
      }
    });
    await API.get(`/public/news/latest/preview?limit=6`).then((resp) => {
      if (!resp.error && resp.data) {
        props.letestNews = resp.data.results;
      }
    });
    await API.get(
      `/public/news/popular-stories/preview?limit=5&newsFormat=standard`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.popularStories = resp.data;
      }
    });
    await API.get(`/public/news/must-read/preview?limit=5`).then((resp) => {
      if (!resp.error && resp.data) {
        props.mustReadNews = resp.data;
      }
    });
    await API.get(
      `/public/news/gallery/preview?limit=5&newsFormat=gallery`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.imageGallery = resp.data.results;
      }
    });
    await API.get(`/public/news/gallery/preview?limit=4&newsFormat=video`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.videoGallery = resp.data.results;
        }
      }
    );
    await API.get(`/public/news/tag-list?newsFormat=standard`).then((resp) => {
      if (!resp.error && resp.data) {
        props.tagsList = resp.data;
      }
    });

    await API.get(`/public/news/distinct-country`).then((resp) => {
      if (!resp.error && resp.data) {
        props.newsCountry = resp.data;
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
